import { jwtDecode } from "jwt-decode";
import React, { useState, useEffect, useContext, useRef } from "react";
import "../styleSheets/userProfile.css";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../Context/UserContext";

function UserProfile() {
  const navigate = useNavigate();
  const refClose = useRef(null);
  const fileRef = useRef(null);

  const { userDetails, getUserProfile } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});

  const [updating, setUpdating] = useState(false);

  // ✅ LOCAL FORM STATE (IMPORTANT FIX)
  const [formData, setFormData] = useState({
    name: "",
    mNumber: "",
    telegramUsername: "",
  });

  // ✅ Load profile once...........(testing)
  // useEffect(() => {
  //   getUserProfile();
  // }, []);

  // ✅ Sync context → local form state

  useEffect(() => {
    if (userDetails && userDetails._id) {
      setFormData({
        name: userDetails.name || "",
        mNumber: userDetails.mNumber || "",
        telegramUsername: userDetails.telegramUsername || "",
      });
    }
  }, [userDetails._id]);

  const token = localStorage.getItem("token");
  let userId = null;

  if (token) {
    const decoded = jwtDecode(token);
    userId = decoded.user.id;
  }

  const validateMobile = (number) => {
    const regex = /^[6-9]\d{9}$/;

    if (!number) return "Mobile number required";
    if (!regex.test(number)) return "Enter valid 10-digit mobile number";

    return "";
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "mNumber") {
      setErrors((prev) => ({
        ...prev,
        mNumber: validateMobile(value),
      }));
    }
  };

  const onUpdate = async (e) => {
    e.preventDefault();

    const mobile = String(formData.mNumber || "").trim();
    const regex = /^[6-9]\d{9}$/;

    if (!regex.test(mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setUpdating(true); // 🔥 start spinner

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/editUser/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": localStorage.getItem("token"),
          },
          body: JSON.stringify({
            name: formData.name,
            mNumber: mobile,
            telegramUsername: formData.telegramUsername,
          }),
        },
      );

      const result = await response.json();

      if (result.success) {
        await getUserProfile();
        alert("Profile updated successfully ✅");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Try again.");
    } finally {
      setUpdating(false); // 🔥 stop spinner
    }
  };

  const uploadProfile = async () => {
    if (!image) return;

    setLoading(true);

    const formDataImage = new FormData();
    formDataImage.append("image", image);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/users/uploadProfilePicture`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formDataImage,
        },
      );

      const data = await res.json();

      if (data.success) {
        await getUserProfile();
        setImage(null);
        fileRef.current.value = "";
        refClose.current.click();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* PROFILE HEADER */}
      <div className="d-flex justify-content-center">
        <div className="dp-cont">
          <div>
            <img
              src={
                userDetails.profilePicture?.url ||
                "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
              }
              className="propic"
              alt="profile"
            />
          </div>

          <div className="proname-cont">
            <h2>{userDetails.name}</h2>

            <div>
              <button
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                className="profile-btn"
              >
                <i className="fa-solid fa-camera mx-1"></i>Update
              </button>

              <button
                className="ms-md-1"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#friendsModal"
              >
                Friends ({userDetails?.friends?.length || 0})
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FORM */}
      <div className="profile-wrapper">
        <form onSubmit={onUpdate} className="profile-form">
          <h2 className="form-title">Update Profile</h2>

          <div className="form-group">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              className="form-input"
              value={formData.name}
              onChange={onChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="mNumber" className="form-label">
              Mobile Number
            </label>
            <input
              type="text"
              id="mNumber"
              name="mNumber"
              className="form-input"
              value={formData.mNumber}
              onChange={onChange}
              maxLength={10}
              inputMode="numeric"
            />
            {errors.mNumber && (
              <small className="form-error">{errors.mNumber}</small>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="text"
              id="email"
              className="form-input disabled-input"
              value={userDetails.email || ""}
              disabled
            />
          </div>

          <div>
            <div className="form-group">
              <label className="form-label">Telegram Username</label>
              <input
                type="text"
                className="form-input"
                placeholder="Enter without @"
                value={formData.telegramUsername}
                name="telegramUsername"
                onChange={onChange}
              />
            </div>
          </div>

          <button
            type="submit"
            className={`primary-btn ${updating ? "btn-loading" : ""}`}
            disabled={updating}
          >
            {updating ? (
              <>
                <span className="btn-spinner"></span>
                Updating...
              </>
            ) : (
              "Update"
            )}
          </button>
        </form>
      </div>

      {/* UPDATE PHOTO MODAL */}
      <div
        className="modal fade profile-modal"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content profile-modal-content">
            {/* Header */}
            <div className="modal-header profile-header">
              <h5 className="modal-title profile-title">
                Update Profile Photo
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body profile-body">
              {/* Preview Section */}
              <div className="image-preview-wrapper">
                {image ? (
                  <img
                    src={URL.createObjectURL(image)}
                    alt="preview"
                    className="image-preview"
                  />
                ) : (
                  <div className="image-placeholder">
                    <span>Select Image</span>
                  </div>
                )}
              </div>

              {/* Custom File Input */}
              <label className="custom-file-upload">
                Choose Photo
                <input
                  type="file"
                  ref={fileRef}
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                  hidden
                />
              </label>

              {/* Upload Button */}
              <button
                className="upload-btn"
                disabled={!image || loading}
                onClick={uploadProfile}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Uploading...
                  </>
                ) : (
                  "Upload Photo"
                )}
              </button>
            </div>

            {/* Footer */}
            <div className="modal-footer profile-footer">
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
                ref={refClose}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FRIENDS MODAL */}
      <div
        className="modal fade friends-modal"
        id="friendsModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content friends-modal-content">
            {/* Header */}
            <div className="modal-header friends-header">
              <h5 className="modal-title friends-title">My Friends</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body friends-body">
              {userDetails?.friends?.length === 0 && (
                <div className="friends-empty">No friends added yet.</div>
              )}

              {userDetails?.friends?.map((e) => (
                <div
                  key={e._id}
                  className="friend-row"
                  onClick={() => {
                    const modalElement =
                      document.getElementById("friendsModal");
                    const modalInstance =
                      window.bootstrap.Modal.getInstance(modalElement);

                    if (modalInstance) modalInstance.hide();

                    setTimeout(() => {
                      document.body.classList.remove("modal-open");
                      document
                        .querySelectorAll(".modal-backdrop")
                        .forEach((el) => el.remove());

                      navigate(`/friendProfile/${e._id}`);
                    }, 250);
                  }}
                >
                  <img
                    className="friend-avatar"
                    src={
                      e.profilePicture?.url ||
                      "https://img.freepik.com/premium-vector/male-face-avatar-icon-set-flat-design-social-media-profiles_1281173-3806.jpg"
                    }
                    alt="friend"
                  />

                  <div className="friend-info">
                    <span className="friend-name">{e.name}</span>
                  </div>

                  <div className="friend-arrow">
                    <i className="fa-solid fa-chevron-right"></i>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="modal-footer friends-footer">
              <button
                type="button"
                className="btn btn-light close-btn"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
